import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

function socialSliders() {

  const instagramSlider = new Swiper('.js-instagram-slider', {
    observer: true, 
    observeParents: true,
    loop: true,
    autoplay: {
      delay: 95000,
    },
    pagination: {
      el: '.instagram-pagination',
      type: 'bullets',
      clickable: true,
    },
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });


  const twitterSlider = new Swiper('.js-twitter-slider', {
    observer: true, 
    observeParents: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.twitter-pagination',
      type: 'bullets',
      clickable: true,
    },
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  

}


export default socialSliders;
